import React from 'react';
import { useEffect, useState,useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import { logininfo, signinfo, resetlogin} from '../modules/userstore';
import { setmenus } from '../modules/menustore';
import { setstickys } from '../modules/environstore';
import axios from "axios";
import MsgBox from '../components/MsgBox';
import {warnmsg} from '../modules/msgboxstore';
import { isEmpty, Savestorage, Getstorage } from '../modules/appLibrary';
import { getAxiosAuthConfig } from '../modules/authToken';
import AccountInfo from "../components/AccountInfo";
import ComFunction from "../components/ComFunction";

// localStorage は同一ドメインの複数環境(/kkaplite, /kkaplite_st 等)で共有されるため、
// 保持するログインKEYは配置パスごとに分離する(ルート直下は従来キーのまま)
const loginMountPath = (() => {
    const baseElement = document.getElementsByTagName('base')[0];
    return baseElement ? new URL(baseElement.href).pathname : '/';
})();
const loginKeyStorageId = loginMountPath === '/' ? 'KEY' : 'KEY@' + loginMountPath;

export const Login = props => {

    const dispatch = useDispatch()
    const history = useHistory()
    const corpkey = useSelector(state => state.user.corpkey);
    const loginkey = useSelector(state => state.user.loginkey);
    const ComFunc = React.forwardRef(ComFunction);

    const fnc = useRef();
    const [version, setversion] = useState('')
    const [update, setupdate] = useState('')
    const [id, setid] = useState('')
    const [password, setpassword] = useState('')
    const [username, setusername] = useState('')
    const [accountopen, setaccountOpen] = useState(false);

    useEffect(() => {
        const body = document.getElementsByTagName('body');
        body[0].classList.add('loginbody');
        var key = "";
        var search = props.location.search;
        if (!isEmpty(search)) {
            let query = new URLSearchParams(search);
            key = query.get("KEY");
            if (!isEmpty(key)) {
                //クエリパラメータKEYログイン保持
                Savestorage("LOGIN","CORP",loginKeyStorageId, key);
            }
            window.history.replaceState(null, '', window.location.pathname); //クエリパラメータ削除(サブパス配置でも実URLを維持)
        } else {
            if (isEmpty(loginkey))
                //クエリパラメータKEYログイン取得
                key = Getstorage("LOGIN", "CORP", loginKeyStorageId);
            else
                key = loginkey
        }
        Initialize(key);
    }, []);

    async function Initialize(key) {
        //get version
        try {
            const res = await axios.get('login/initialize' + (isEmpty(key)?'':'/?key=' + key));
            const data = res.data;
            var datas = data.request.split(",");
            setversion(datas[0]);
            setupdate(datas[1]);
            if (!isEmpty(key)) {
                if (!isEmpty(data.returnData)) {
                    //クエリパラメータKeyログイン
                    let user = { version: datas[0], corpname: data.returnData["name"], corpkey: data.returnData["key"], dbid: data.returnData["id"], debug: false, loginkey:key };
                    dispatch(logininfo(user));
                    setusername(data.returnData["name"]);
                }
            }
        } catch (error) {
        }
    }

    function handleInputChange(e){
        if(e.target.name === "id") 
            setid(e.target.value);
        else
            setpassword(e.target.value);
    }

    async function LoginAction(e) {
        try {
            e.preventDefault();
            let param = new FormData();
            if (isEmpty(loginkey)) { //通常ログイン
                param.append('id', id);
                param.append('password', password);
                const res = await axios.post('login/execute', param, getAxiosAuthConfig());
                const data = res.data;
                if (data.status) {
                    let user = { version: version, corpname: data.returnData["name"], corpkey: data.returnData["key"], dbid: data.returnData["id"], debug: password === '571217', loginkey:'' };
                    dispatch(logininfo(user));
                    const body = document.getElementsByTagName('body');
                    body[0].classList.remove('loginbody');
                    history.push('/top')
                } else {
                    dispatch(warnmsg(data.errDescription));
                }
            } else {                    //クエリパラメータKEYログイン
                if (id === "kkplm") {
                    //通常ログインへ
                    setid("");
                    setpassword("");
                    setusername("");
                    dispatch(resetlogin());
                    return;
                }
                param.append('corpkey', corpkey);
                param.append('account', id);
                param.append('password', password);
                const res = await axios.post('login/signin', param, getAxiosAuthConfig());
                const data = res.data;
                if (data.status) {
                    let info = {
                        account: id, name: data.returnData["name"], authority: data.returnData["admin"],
                        role: data.returnData["role"], staff: data.returnData["staff"], accctl: data.data
                    };
                    dispatch(signinfo(info));
                    //get menu
                    param.append('role', data.returnData["role"]);
                    const res2 = await axios.post('menu/getmenu', param, getAxiosAuthConfig());
                    const menudata = res2.data;
                    if (data.status) {
                        let menu = {
                            category: menudata.category,
                            menus: menudata.menus,
                            menudefs: menudata.menudefs,
                            original: menudata.original,
                            menucolors: menudata.colors,
                            recievemsg: menudata.recievemsg,
                            sendmsg: menudata.sendmsg,
                            washmark: menudata.washmark,
                            dashboard: menudata.dashboard
                        };
                        dispatch(setmenus(menu));
                        dispatch(setstickys({ stickys: menudata.stickys, stickycolor: menudata.stickycolor }));
                    } else {
                        dispatch(warnmsg(data.errDescription));
                        return;
                    }

                    if (data.returnData["reset"] === "1") {
                        //初回パスワード変更
                        fnc.current.infomsg("パスワードの設定をしてください", () => setaccountOpen(true));
                    } else if (data.returnData["expired"] === "1") {
                        //パスワード有効期限切れ
                        fnc.current.infomsg("パスワードの有効期限が切れています。パスワードを変更してください。", () => setaccountOpen(true));
                    } else {
                        completeLogin();
                    }
                } else {
                    dispatch(warnmsg(data.errDescription));
                }
            }
        } catch (error) {
        //    const { status, statusText } = error.response;
        //    console.log(`Error! HTTP Status: ${status} ${statusText}`);
        }
    }
    function completeLogin() {
        const body = document.getElementsByTagName('body');
        body[0].classList.remove('loginbody');
        setaccountOpen(false);
        history.push('/top')
    }

    const useStyles = makeStyles((theme) => ({
        root: {
            "& .MuiFilledInput-root": {
                background: "rgb(256, 256, 256)"
            }
        }
    }));
    const classes = useStyles();
     return (
        <div>
             <ComFunc ref={fnc} />
            <div style={{ position: 'fixed', bottom: 0, width: '100%', height: 500, textAlign: 'right' }}>
                <span className="logofont" style={{ fontSize: 500, marginRight: 50, color: '#3C4D4A' }}>&</span>
             </div>
             <div className="logofont" style={{ position: 'absolute', top: 30, right: 70, fontSize: 20, color: '#fff' }}>
                 {username}
            </div>
             <div className="logofont" style={{ fontSize: 30, marginTop: 50, marginLeft: 50, color: '#999999' }}>
                 KKAP Lite
                 <span className="loginlogo" style={{ fontSize: 15, marginLeft: 20 }}> version {version}</span>
                 <span className="loginlogo" style={{ fontSize: 10, marginLeft: 50 }}> -- v2.1.2 </span>
             </div>
            <div className="logofont" style={{ fontSize: 15, marginTop: 30, marginLeft: 50, color: '#999999' }}>
                <div>production</div>
                <div>ordering</div>
                <div>sales</div>
                <div>inventory</div>
                <div>management system</div>
             </div>
            <div style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, margin: 'auto', width: 300, height: 300 }}>
                <TextField
                    autoFocus
                    margin="dense"
                    name="id"
                    label="ID"
                    type="text"
                    fullWidth
                    onChange={handleInputChange}
                        variant="filled" 
                        className={classes.root}
                    />
                <TextField
                    margin="dense"
                    name="password"
                    label="Password"
                    type="password"
                    fullWidth
                    onChange={handleInputChange}
                        variant="filled"
                        className={classes.root}
                />

                <div style={{ marginTop: 10 }}>
                    <Button variant="contained" fullWidth onClick={LoginAction} className={classes.text}>LOGIN</Button> 
                </div>
            </div>
             <AccountInfo
                 show={accountopen}
                 fnc={fnc}
                 doClose={() => setaccountOpen(false)}
                 passwordChanged={completeLogin}
              />
            <MsgBox />
        </div>
    );
}
